(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Whipped-balm texture for empty photo slots ---------- */
  function rng(seed) { var s = seed >>> 0; return function () { s = (s * 1664525 + 1013904223) >>> 0; return s / 4294967296; }; }
  function makeNoise(seed) {
    var r = rng(seed), p = new Uint8Array(512), g = [], i, j, t;
    for (i = 0; i < 256; i++) { p[i] = i; var a = r() * Math.PI * 2; g.push([Math.cos(a), Math.sin(a)]); }
    for (i = 255; i > 0; i--) { j = Math.floor(r() * (i + 1)); t = p[i]; p[i] = p[j]; p[j] = t; }
    for (i = 0; i < 256; i++) p[i + 256] = p[i];
    function fade(v) { return v * v * v * (v * (v * 6 - 15) + 10); }
    function dot(h, x, y) { var v = g[h & 255]; return v[0] * x + v[1] * y; }
    return function (x, y) {
      var xi = Math.floor(x), yi = Math.floor(y), xf = x - xi, yf = y - yi;
      var aa = p[p[xi & 255] + (yi & 255)], ab = p[p[xi & 255] + ((yi + 1) & 255)];
      var ba = p[p[(xi + 1) & 255] + (yi & 255)], bb = p[p[(xi + 1) & 255] + ((yi + 1) & 255)];
      var u = fade(xf), v = fade(yf);
      var x1 = dot(aa, xf, yf) + u * (dot(ba, xf - 1, yf) - dot(aa, xf, yf));
      var x2 = dot(ab, xf, yf - 1) + u * (dot(bb, xf - 1, yf - 1) - dot(ab, xf, yf - 1));
      return x1 + v * (x2 - x1);
    };
  }
  function paint(fig) {
    var c = fig.querySelector('canvas');
    if (!c) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = fig.clientWidth, h = fig.clientHeight;
    if (!w || !h) return;
    c.width = Math.round(w * dpr); c.height = Math.round(h * dpr);
    var ctx = c.getContext('2d'); ctx.scale(dpr, dpr);
    var seed = +fig.getAttribute('data-seed') || 1, density = +fig.getAttribute('data-density') || 1;
    var flow = makeNoise(seed), mask = makeNoise(seed + 101), r = rng(seed + 7);
    ctx.fillStyle = '#C9DADB'; ctx.fillRect(0, 0, w, h);
    var grd = ctx.createRadialGradient(w * .35, h * .3, 0, w * .5, h * .5, Math.max(w, h) * .8);
    grd.addColorStop(0, 'rgba(255,255,255,.18)'); grd.addColorStop(1, 'rgba(120,145,150,.35)');
    ctx.fillStyle = grd; ctx.fillRect(0, 0, w, h);
    var tones = ['228,238,238', '214,229,230', '168,190,193', '140,165,170'];
    var count = Math.round((w * h) / 80 * density), scale = 1 / 170;
    ctx.lineCap = 'round';
    for (var i = 0; i < count; i++) {
      var x = r() * w, y = r() * h;
      var m = mask(x * scale * .55, y * scale * .55);
      
      var tv = r(), tone = tv < .5 ? tones[0] : tv < .85 ? tones[1] : tv < .97 ? tones[2] : tones[3];
      ctx.strokeStyle = 'rgba(' + tone + ',' + (.10 + Math.abs(m) * .25).toFixed(3) + ')';
      ctx.lineWidth = .6 + r() * 1.9;
      ctx.beginPath(); ctx.moveTo(x, y);
      for (var s = 0; s < 22; s++) {
        var ang = flow(x * scale, y * scale) * Math.PI * 3;
        x += Math.cos(ang) * 2.4; y += Math.sin(ang) * 2.4;
        ctx.lineTo(x, y);
      }
      ctx.stroke();
    }
    for (var k = 0; k < (w * h) / 1400; k++) {
      var px = r() * w, py = r() * h, rad = 2 + r() * 7;
      ctx.fillStyle = 'rgba(255,255,255,' + (.35 + r() * .4) + ')';
      ctx.beginPath(); ctx.arc(px, py, rad, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = 'rgba(90,115,120,.10)';
      ctx.beginPath(); ctx.arc(px + rad * .5, py + rad * .6, rad, 0, Math.PI * 2); ctx.fill();
    }
  }
  function paintAll() { document.querySelectorAll('.slot[data-seed]').forEach(paint); }
  var resizeTimer;
  window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(paintAll, 150); });
  document.addEventListener('shopify:section:load', paintAll);

  /* ---------- Cart count ---------- */
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  /* ---------- AJAX add to cart (forms fall back to a normal POST) ---------- */
  function bindAddForms(scope) {
    (scope || document).querySelectorAll('form[data-ajax-add]').forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var status = form.querySelector('.status');
        if (btn) btn.setAttribute('aria-disabled', 'true');
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (result) {
            if (!result.ok) throw new Error(result.data.description || result.data.message || 'That size could not be added.');
            if (status) status.innerHTML = 'Added. <a href="' + root + 'cart">View bag</a>';
            return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
          })
          .then(function (cart) { if (cart) setCount(cart.item_count); })
          .catch(function (err) {
            if (status) { status.textContent = err.message; status.classList.add('form-error'); }
          })
          .finally(function () { if (btn) btn.removeAttribute('aria-disabled'); });
      });
    });
  }

  /* ---------- Product page: variant picker, quantity, gallery ---------- */
  function bindProduct(scope) {
    (scope || document).querySelectorAll('[data-product-form]').forEach(function (wrap) {
      var dataEl = wrap.querySelector('script[data-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var idInput = wrap.querySelector('input[name="id"]');
      var priceEl = wrap.querySelector('[data-price]');
      var btn = wrap.querySelector('[data-add-button]');
      var btnLabel = wrap.querySelector('[data-add-label]');
      wrap.querySelectorAll('input[name="variant-choice"]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          var v = variants.find(function (x) { return String(x.id) === radio.value; });
          if (!v) return;
          idInput.value = v.id;
          if (priceEl) priceEl.innerHTML = (v.compare ? '<s>' + v.compare + '</s>' : '') + v.price;
          if (btn) btn.disabled = !v.available;
          if (btnLabel) btnLabel.textContent = v.available ? 'Add to bag' : 'Sold out';
          if (v.image) {
            var main = document.querySelector('[data-main-image]');
            if (main) { main.src = v.image; main.removeAttribute('srcset'); main.classList.remove('lid'); }
          }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      });
      var qty = wrap.querySelector('.qty input');
      wrap.querySelectorAll('.qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          var next = Math.max(1, (parseInt(qty.value, 10) || 1) + (+b.getAttribute('data-step')));
          qty.value = next;
        });
      });
    });
    (scope || document).querySelectorAll('.pdp-thumbs button').forEach(function (b) {
      b.addEventListener('click', function () {
        var main = document.querySelector('[data-main-image]');
        if (!main) return;
        main.src = b.getAttribute('data-src');
        main.removeAttribute('srcset');
        main.classList.remove('lid');
        document.querySelectorAll('.pdp-thumbs button').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
      });
    });
  }

  function init(scope) { paintAll(); bindAddForms(scope); bindProduct(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(paintAll);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
